<div
  class="workspace-container"
  [class.sidebar-collapsed]="isSidebarCollapsed"
  [class.mobile-menu-open]="isMobileMenuOpen"
>
  <aside class="sidebar">
    <app-proctoring-sidebar
      [isCollapsed]="isSidebarCollapsed"
      [activeTab]="activeTab"
      (activeTabChange)="setActiveTab($event)"
      (toggleCollapse)="toggleSidebar()"
      (logout)="logout()"
    >
    </app-proctoring-sidebar>
  </aside>

  <main class="main-content">
    <app-proctoring-header
      [isSidebarCollapsed]="isSidebarCollapsed"
      (toggleMobileMenu)="toggleMobileMenu()"
      (globalSearch)="onGlobalSearch($event)"
      (logout)="logout()"
    >
    </app-proctoring-header>
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
